import { z } from 'zod';

const base = {
  id: z.string().min(1),
  rect: z.object({
    x: z.number().int().nonnegative(),
    y: z.number().int().nonnegative(),
    w: z.number().int().positive(),
    h: z.number().int().positive()
  }),
  on: z.object({ tap: z.array(z.lazy(() => ActionSchema)).optional() }).optional()
};
import { ActionSchema } from '../actions';

const schedule = z.object({
  days: z.array(z.number().int().min(0).max(6)),
  from: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
  to: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/)
});

export const MediaBlockSchema = z.object({
  ...base,
  type: z.literal('media'),
  props: z.object({
    mode: z.enum(['single', 'playlist']),
    fit: z.enum(['cover', 'contain']),
    items: z.array(z.object({
      media_id: z.string().min(1),
      kind: z.enum(['image', 'video']),
      duration_s: z.number().int().min(1).max(3600),
      schedule: schedule.optional()
    })),
    fallback_text: z.string().optional()
  })
});